// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"abdbc182","453":"63053b66"}[chunkId] + ".chunk.js";
};